import { motion } from 'framer-motion'
import './DataCard.css'
import {
  FaJava, FaJs, FaPython, FaReact, FaNode, FaServer, FaDatabase,
  FaCode, FaGithub, FaGitlab, FaAndroid, FaMicrosoft,
  FaHtml5, FaCss3Alt, FaLayerGroup,
  FaIndustry, FaUser, FaUniversity
} from 'react-icons/fa'
import { SiSpring, SiMongodb, SiMysql, SiFirebase, SiJira, SiSublimetext, SiVisualstudiocode } from 'react-icons/si'

const iconMap = {
  'Java': <FaJava />,
  'JavaScript': <FaJs />,
  'Python': <FaPython />,
  'React Js': <FaReact />,
  'Next Js': <FaReact />,
  'Node Js': <FaNode />,
  'Spring Boot': <SiSpring />,
  'VS Code': <SiVisualstudiocode />,
  'Android Studio': <FaAndroid />,
  'Visual Studio': <FaMicrosoft />,
  'Eclipse': <FaCode />,
  'MySQL': <SiMysql />,
  'Navicat': <FaDatabase />,
  'Mongo DB': <SiMongodb />,
  'Firebase': <SiFirebase />,
  'GitHub': <FaGithub />,
  'GitLab': <FaGitlab />,
  'Sublime Text': <SiSublimetext />,
  'Jira': <SiJira />,
  'HTML': <FaHtml5 />,
  'CSS': <FaCss3Alt />,
  'MVC': <FaLayerGroup />,
  'MERN Stack': <FaServer />,
  'Flutter': <FaCode />,
  'Industrial': <FaIndustry />,
  'Personal': <FaUser />,
  'Academic': <FaUniversity />,
  'default': <FaCode />
}

const getIcon = (name) => {
  return iconMap[name] || iconMap['default']
}

const DataCard = ({ fields, links, badge, icon }) => {
  const Component = badge ? 'div' : motion.div
  const props = badge ? {} : {
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: '-50px' },
    transition: { duration: 0.5 },
    whileHover: { y: -5 }
  }

  const renderIcon = icon || (badge ? getIcon(fields[0]) : null)

  return (
    <Component className={`data-card ${badge ? 'data-card--badge' : ''}`} {...props}>
      <div className="data-card__inner">
        {renderIcon && (
          <span className={`data-card__icon ${badge ? 'data-card__icon--badge' : ''}`}>
            {renderIcon}
          </span>
        )}
        {fields.map((field, i) => (
          <span key={i} className={`data-card__field data-card__field--${i}`}>
            {field}
          </span>
        ))}
        {links?.map((link, i) => (
          <a key={i} href={link.url} target="_blank" rel="noopener noreferrer" className="data-card__link">
            {link.label} &rarr;
          </a>
        ))}
      </div>
    </Component>
  )
}

export default DataCard
